<template>
  <div>

    <!--<v-tabs grow>-->
    <!--<v-tab>Item 1</v-tab>-->
    <!--<v-tab>Item 2</v-tab>-->
    <!--<v-tab>Item 3</v-tab>-->
    <!--</v-tabs>-->
    <!--<v-divider></v-divider>-->
    <div>test router 3 {{Math.random() * 1000}}</div>
    <!--<h1>//{{$vuetify.breakpoint.name}}//</h1>-->
    <v-btn @click="dialog = !dialog">trigger error</v-btn>
    <l-operation-dialog sub-text="您所做的操作将不会保存" text="确认离开此页?" title="确认离开">
      <v-btn slot="activator">trigger operation</v-btn>
    </l-operation-dialog>
    <l-alert type="success snackbar">
      <v-btn slot="activator">alert</v-btn>
    </l-alert>
    <v-btn @click="$L.alert( 'success', {message:'test'})">global</v-btn>
    <v-btn @click="$store.dispatch('L/closeAlert')">close</v-btn>
    <v-btn @click="testLogout">logout</v-btn>
  </div>
</template>

<script>

export default {
  name: 'testRouter3',
  data: () => ({
    dialog: false,
  }),
  methods: {
    testLogout () {
      this.$store.dispatch('login/logoutCount', {second: 10})
    }
  }
}
</script>

<style scoped>

</style>
